import { DiscountContent } from "../../components/adjustment";

export default function InvoiceDiscount() {
  return <DiscountContent />;
}
